<script lang="ts">
    import Option from "../../application/SyllabusManager/models/Option.ts";
    import {Switch, Button, Toast} from 'svelma';
    import {_} from "svelte-i18n";

    export let optionStore;
    export let modalActive;

    let option : Option = $optionStore;
    $: option = $optionStore;

    function closeModal(){
        optionStore.set(option);
        $modalActive = !$modalActive;
        Toast.create({message: $_('options.message'),type: 'is-info', position: 'is-top'});
    }
</script>

<div class="card p-5">
    <h1 class="title">{$_('options.optionsTitle')}: </h1>
    <div class="divider">{$_('options.semesters')}</div>
        <div class="semesterSwitches grid split">
            {#each option.semesters as semester}
                <Switch  class="is-centered" bind:checked={semester.value} type="is-info">{semester.name}. {$_('panel.semester')}</Switch>
            {/each}
        </div>
    <div class="divider">{$_('options.spec')}</div>
        <div class="moduleSwitches grid">
            {#each option.modules as module}
                <Switch  class="is-centered" bind:checked={module.value} type="is-info">{module.name}</Switch>
            {/each}
        </div>
    <div class="block mt-5 is-right columns">
        <div class="column"></div>
        <div class="column is-narrow">
            <Button iconPack="fa" iconRight="save" on:click={closeModal}>{$_('options.save')}</Button>
        </div>
    </div>
</div>

<style>
    .grid {
        display:grid;
        grid-row-gap: 10px;
    }

    .split{
        grid-template-columns: auto auto;
    }
</style>